import ajax from 'utils/request';

function request(tyep,url,params){
    return ajax(tyep,url,params,true,true).then(res=>{
        res.accountType = 'old';
        return res;
    }).catch(res=>{
        const data = {
            code:res.data.errcode || 4,
            msg:res.data.errmsg || 'Error'
        };
        const error = {
            code:4,
            msg: 'Error'
        };
        return Promise.reject({data,error});
    });
}

export function login(username,password,captcha) {
    const params = {
        username,password,
        region:'oversea'
    };
    if(captcha){
        params.captcha = captcha;
    }
    return request('POST','/user/login',params);
}

export function forgetPassword(username,email) {
    const params = {
        username,email
    };
    return request('POST','/user/send_recover_password_email',params);
}

export function resetPassword(params) {
    return request('POST','/user/reset_password',params);
}

export function oldVerifyGetToken(token) {
    return request('POST','/user/login/step2/send_sms',{token});
}

export function oldVerifyLogin(params) {
    return request('POST','/user/login/step2/sms',params);
}

export function oldCheckLogin() {
    return ajax('GET','/accounts/accounts_info',null,true,true);
}

//其他
export function logout() {
    return ajax('GET', '/user/logout',{},true);
}
export function getAccountInfo(notAutoGoLogin) {
    return function (dispatch) {
        return request('GET', '/accounts/accounts_info',null,true,notAutoGoLogin).then(e=>{
            dispatch({ type:'GET_BASE_ACCOUNT_INFO', data: e.data });
        }).catch(()=>{
            dispatch({ type: 'GET_BASE_ACCOUNT_FAIL'});
        });
    };
}

// export function setUserInfo(data) {
//     return function(dispatch) {
//         dispatch({ type: url+'GET_BASE_ACCOUNT_INFO', data});
//     };
// }


export function oldSendSecondCode(params) {
    return request('POST','/user/login/step2/send',params);

}

export function oldSecondLogin(params) {
    return request('POST','/user/login/step2/check',params);

}



// WEBPACK FOOTER //
// ./src/actions/oldAccount.js